import { formatNumber, formatDOS } from '../../utils/format'

const MONTHS = [
  { key: 'apr26', label: 'Apr 2026' },
  { key: 'may26', label: 'May 2026' },
  { key: 'jun26', label: 'Jun 2026' },
  { key: 'jul26', label: 'Jul 2026' },
  { key: 'aug26', label: 'Aug 2026' },
  { key: 'sep26', label: 'Sep 2026' },
]

function monthColumns(month, monthIndex) {
  const isOdd = monthIndex % 2 === 1
  const bgColor = isOdd ? '#F8F9FA' : '#FFFFFF'
  const separatorBorder = '2px solid #94A3B8'

  return [
    {
      headerName: '%MinInv',
      field: `${month.key}_pctMinInv`,
      width: 76,
      type: 'numericColumn',
      valueFormatter: (p) => (p.value != null ? `${(p.value * 100).toFixed(0)}%` : '—'),
      cellStyle: {
        padding: '0 4px',
        backgroundColor: bgColor,
        borderLeft: separatorBorder,
      },
    },
    {
      headerName: 'DOS',
      field: `${month.key}_dos`,
      width: 68,
      type: 'numericColumn',
      cellRenderer: 'dosCellRenderer',
      cellStyle: { padding: '0 4px', backgroundColor: bgColor },
    },
    {
      headerName: 'FCST',
      field: `${month.key}_fcst`,
      width: 80,
      type: 'numericColumn',
      valueFormatter: (p) => formatNumber(p.value),
      cellStyle: { padding: '0 4px', backgroundColor: bgColor },
    },
    {
      headerName: 'CASES',
      field: `${month.key}_cases`,
      width: 84,
      type: 'numericColumn',
      editable: true,
      cellRenderer: 'casesCellRenderer',
      cellStyle: { padding: '0 4px', backgroundColor: bgColor },
    },
    {
      headerName: 'HRS',
      field: `${month.key}_hrs`,
      width: 64,
      type: 'numericColumn',
      valueFormatter: (p) => (p.value != null ? p.value.toFixed(1) : '—'),
      cellStyle: { padding: '0 4px', backgroundColor: bgColor },
    },
  ]
}

export function getColumnDefs() {
  const frozenCols = [
    {
      headerName: '',
      field: 'hasIssue',
      width: 44,
      pinned: 'left',
      cellRenderer: 'issueCellRenderer',
      sortable: false,
      filter: false,
      resizable: false,
      suppressMovable: true,
      cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 },
    },
    {
      headerName: 'Line',
      field: 'line',
      width: 56,
      pinned: 'left',
      filter: true,
      cellStyle: { fontWeight: 600 },
    },
    {
      headerName: 'Brite',
      field: 'briteCode',
      width: 74,
      pinned: 'left',
      filter: true,
    },
    {
      headerName: 'Item #',
      field: 'itemNumber',
      width: 130,
      pinned: 'left',
      filter: true,
      cellStyle: { fontFamily: 'monospace', fontSize: '0.8rem' },
    },
    {
      headerName: 'Description',
      field: 'description',
      width: 220,
      pinned: 'left',
      filter: true,
      tooltipField: 'description',
    },
    {
      headerName: 'Min',
      field: 'dosMin',
      width: 56,
      pinned: 'left',
      type: 'numericColumn',
      valueFormatter: (p) => formatNumber(p.value),
    },
    {
      headerName: 'Max',
      field: 'dosMax',
      width: 56,
      pinned: 'left',
      type: 'numericColumn',
      valueFormatter: (p) => formatNumber(p.value),
    },
    {
      headerName: 'Auto',
      field: 'autoInv',
      width: 52,
      pinned: 'left',
      cellRenderer: (p) => p.value ? '✓' : '',
      cellStyle: (p) => ({
        textAlign: 'center',
        color: p.value ? '#1A9E2A' : '#758075',
        fontWeight: 600,
      }),
    },
    {
      headerName: '% Min',
      field: 'percentOfMinInv',
      width: 68,
      pinned: 'left',
      type: 'numericColumn',
      valueFormatter: (p) => (p.value != null ? `${(p.value * 100).toFixed(0)}%` : '—'),
    },
  ]

  const monthGroups = MONTHS.map((m, i) => ({
    headerName: m.label,
    headerClass: 'month-header-group',
    headerGroupComponent: undefined,
    children: monthColumns(m, i),
  }))

  return [...frozenCols, ...monthGroups]
}

export { MONTHS }

export const defaultColDef = {
  sortable: true,
  resizable: true,
  suppressHeaderMenuButton: true,
  cellStyle: { fontSize: '0.8125rem', lineHeight: '36px' },
}

export const gridOptions = {
  rowHeight: 36,
  headerHeight: 32,
  groupHeaderHeight: 28,
  animateRows: false,
  suppressCellFocus: false,
  enableCellTextSelection: true,
  rowSelection: { mode: 'multiRow', enableClickSelection: false },
  getRowId: (params) => params.data.itemNumber,
}
